import * as React from 'react';

export class ZendeskSvg extends React.Component<{}> {

  render() {
    return (
      <svg
          version="1.1"
          id="Layer_1"
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          x="0px"
          y="0px"
          viewBox="0 0 50 50"
          xmlSpace="preserve"
      >
        <g>
          <g>
            <g>
              <g>
                <g>
                  <g>
                    <circle fill="#78C047" cx="25" cy="25" r="24"/>
                  </g>
                </g>
              </g>
            </g>
          </g>
          <path
              fill="#FFFFFF"
              d="M34.4,38.1c-0.8,0-1.6-0.1-2.4-0.3c-2.5-0.6-4.6-2.2-5.9-4.2c0.1,0.1,0.2,0.2,0.2,0.3c0.9-0.5,2.7-1.5,4.3-3c0.9,0.4,2,0.5,3.1,
              0.5c1.7,0,3.4-0.4,4.9-1.3c-0.1-0.1-0.1-0.3-0.2-0.4c0,0,0,0,0,0c0.8,1.5,1.2,3.1,1.2,4.6c0,0.9-0.1,1.7-0.3,2.5C37.8,37.6,
              36.2,38.1,34.4,38.1"
          />
          <path
              fill="#FFFFFF"
              d="M32.8,29.5c-0.4,0-0.9,0-1.3-0.1c0,0,0,0,0,0c0.2,0,0.4,0,0.6,0c1.3-1.5,2.3-3.4,2.3-5.5c0-0.4,0-0.8-0.1-1.1c1.2-1.3,2.1-3.1,
              2.3-5l0-0.1l0,0c0.1,0,0.2,0.1,0.3,0.1c2.2,0.5,4.1,1.8,5.5,3.5l0-0.2c0,0,0,0,0,0c-0.4,2.4-1.6,4.7-3.7,6.3C37,28.8,34.9,29.5,32.8,29.5"
          />
          <path
              fill="#FFFFFF"
              d="M25.8,11.4C25.8,11.4,25.8,11.3,25.8,11.4C25.7,11.3,25.7,11.3,25.8,11.4C25.8,11.3,25.8,11.4,25.8,11.4"
          />
          <path
              fill="#FFFFFF"
              d="M33.4,20.7c-0.9-1.4-2.4-2.2-4-2.2h-0.1c-0.4,0-0.8,0-1.2,0.2c0,0,0,0,0,0c0.1,0,0.1,0,0.2,
              0l0-0.1c0-1.6-0.3-3.1-1-4.6c-0.3-0.8-0.8-1.5-1.3-2.2c1.8-1.6,3.9-2.4,6.2-2.4h0.1c0.6,0.6,1.1,1.3,1.5,
              2.1c-0.3-0.7-0.8-1.4-1.3-2c1.4,1.7,2.2,3.9,2.2,6.3C34.8,17.4,34.3,19.2,33.4,20.7"
          />
          <path
              fill="#FFFFFF"
              d="M25.2,20.9c-0.8-1.6-2.3-2.3-3.8-2.4c-1.8-1.7-4.2-2.8-6.9-2.8c-0.1,0-0.2,0-0.3,0l0,0c0.1,0,0.2,0,0.2,0c0.1-2.4,1-4.6,
              2.6-6.3c0.1,0,0.2,0,0.3,0c2.3,0,4.7,0.8,6.5,2.5c1,0.9,1.7,1.9,2.3,3c-0.3-0.8-0.8-1.6-1.4-2.3c1.4,1.8,2.2,4,2.2,6.2c0,0.1,0,
              0.2,0,0.3C26.3,19.4,25.6,20.1,25.2,20.9"
          />
          <path
              fill="#FFFFFF"
              d="M10.6,27.4c-1.6-1.2-2.7-2.9-3.3-4.6c0.2,0.5,0.3,0.9,0.6,1.3c-0.3-0.8-0.6-1.6-0.7-2.4c1.4-1.9,3.6-3.4,6.2-3.8c0.6-0.1,1.2-0.2,
              1.7-0.2c1.5,0,3,0.4,4.3,1c0.1,0,0.3-0.1,0.4-0.1c0,0,0,0,0,0c-1.9,0.5-3.6,2.2-3.6,4.8c0,0.1,0,0.2,0,0.3C14.1,24.2,12.1,25.4,10.6,27.4"
          />
          <path
              fill="#FFFFFF"
              d="M15.1,38.2c-1.7,0-3.3-0.4-4.7-1.2c0,0,0,0,0,0l0.1,0.1c-0.2-0.7-0.2-1.5-0.2-2.3c0-1.6,0.4-3.1,1.2-4.6c1.2-2.2,
              3-3.8,5.2-4.6c0-0.2-0.1-0.3-0.1-0.5c0,0,0,0,0,0c0.2,0.7,0.4,1.3,0.7,1.9c0,0,0,0,0-0.1c0.4,0.9,1,1.8,1.7,2.6l0.1-0.1c0,0,0,0,0,0c-1.2,
              1.7-1.9,3.7-1.9,5.8c0,0.9,0.1,1.8,0.4,2.7C16.7,38.1,15.9,38.2,15.1,38.2"
          />
          <path
              fill="#FFFFFF"
              d="M24.7,33.8c0-0.1-0.1-0.1-0.1-0.2c0,0,0,0,0,0C24.7,33.6,24.7,33.7,24.7,33.8"
          />
          <path
              fill="#FFFFFF"
              d="M24.9,43.9c-2.2-0.9-4.1-2.6-5.2-5c0,0.1,0.1,0.2,0.1,0.2c-0.6-1.3-0.8-2.6-0.8-3.9c0-1.6,0.4-3.1,1.1-4.5c1.9,1.7,3.9,2.9,4.8,3.3c0.1,
              0.2,0.2,0.4,0.3,0.6c0-0.1-0.1-0.1-0.1-0.2c0.9,2,2.6,3.7,4.8,4.7c0-0.1,0.1-0.2,0.1-0.3c0,0,0,0,0,0C28.9,41.2,27.1,43,24.9,43.9"
          />
          <path
              fill="#E0E0E0"
              d="M26.3,33.9c-0.1-0.1-0.2-0.2-0.2-0.3c0,0,0,0,0-0.1c0.9-0.5,2.7-1.5,4.4-3c0.9,0.4,2,0.5,3.1,0.5c1.7,0,3.4-0.4,4.9-1.3c0.1,0.1,0.1,
              0.3,0.2,0.4c-1.6,0.9-3.3,1.3-4.9,1.3c-1.1,0-2.2-0.2-3.1-0.5C29,32.3,27.3,33.4,26.3,33.9"
          />
          <path
              fill="#E0E0E0"
              d="M32.1,29.4c-0.2,0-0.4,0-0.6,0c1.5-1.6,2.7-3.6,2.7-5.9c0-0.4,0-0.8-0.1-1.1c1.2-1.3,2.1-3.1,2.3-5l0-0.1c0.1,0,0.2,0.1,0.4,0.1c2.3,
              0.6,4.4,1.9,5.8,3.7l0,0.2c-1.4-1.7-3.4-2.9-5.5-3.5c-0.1,0-0.2-0.1-0.3-0.1l0,0l0,0.1c-0.3,2-1.1,3.7-2.3,5c0.1,0.3,0.1,0.7,0.1,1.1C34.4,
              26,33.4,27.9,32.1,29.4"
          />
          <path
              fill="#E0E0E0"
              d="M26,11.7c-0.1-0.1-0.2-0.2-0.2-0.3c0,0-0.1-0.1-0.1-0.1c1.9-1.7,3.9-2.5,6.3-2.5h0.1c0.2,0.2,0.3,0.3,0.5,0.5c0.5,0.6,0.9,1.3,1.3,
              2c-0.4-0.8-0.9-1.5-1.5-2.1h-0.1C29.9,9.2,27.9,10,26,11.7"
          />
          <path
              fill="#E0E0E0"
              d="M28.1,18.6c0-0.2,0-0.4,0-0.6c0-1.4-0.2-2.8-0.8-4.1c0.7,1.4,1,3,1,4.6l0,0.1C28.3,18.5,28.2,18.6,28.1,18.6"
          />
          <path
              fill="#E0E0E0"
              d="M14.2,15.6L14.2,15.6c0-2.6,1-4.9,2.6-6.7c0.1,0,0.2,0,0.3,0c2.3,0,4.7,0.8,6.5,2.5c0.4,0.4,0.8,0.8,1.1,1.2c0.6,0.7,1,1.5,1.4,
              2.3c-0.5-1.1-1.3-2.1-2.3-3c-1.9-1.7-4.2-2.5-6.5-2.5c-0.1,0-0.3,0-0.3,0c-1.5,1.7-2.5,3.9-2.6,6.3C14.3,15.6,14.3,15.6,14.2,15.6"
          />
          <path
              fill="#E0E0E0"
              d="M7.9,24.1c-0.2-0.4-0.4-0.9-0.6-1.3c-0.2-0.5-0.3-1-0.4-1.5c1.4-1.9,3.6-3.4,6.2-3.8c0.6-0.1,1.2-0.2,1.7-0.2c1.8,0,3.5,0.5,4.9,
              1.3c-0.1,0-0.3,0.1-0.4,0.1c-1.3-0.7-2.8-1-4.3-1c-0.6,0-1.2,0-1.7,0.2c-2.6,0.5-4.8,1.9-6.2,3.8C7.3,22.5,7.5,23.3,7.9,24.1"
          />
          <path
              fill="#E0E0E0"
              d="M18.9,29.5c-0.7-0.8-1.3-1.7-1.7-2.6c0,0,0,0,0,0.1c0.5,0.9,1.1,1.7,1.8,2.4L18.9,29.5"
          />
          <path
              fill="#E0E0E0"
              d="M10.5,37l-0.1-0.1c-0.2-0.8-0.3-1.7-0.3-2.7c0-1.6,0.4-3.1,1.2-4.6c1.2-2.2,3.1-3.8,5.3-4.6c0,0.2,0.1,0.3,0.1,0.5c-2.2,0.8-4,2.4-5.2,
              4.6c-0.8,1.5-1.2,3-1.2,4.6C10.2,35.5,10.3,36.3,10.5,37"
          />
          <path
              fill="#E0E0E0"
              d="M29.8,39.1c-2.2-1-3.8-2.7-4.8-4.7c0,0.1,0.1,0.1,0.1,0.2c1,1.8,2.7,3.3,4.8,4.2C29.9,39,29.9,39,29.8,39.1"
          />
          <path
              fill="#E0E0E0"
              d="M19.8,39.2c0-0.1-0.1-0.2-0.1-0.2c0,0,0-0.1-0.1-0.1c-0.6-1.3-0.9-2.7-0.9-4c0-1.6,0.4-3.1,1.1-4.5c1.9,1.7,4,2.9,4.8,3.3c0,0.1,0,0.1,
              0.1,0.2c0,0.1,0.1,0.2,0.1,0.3c-0.8-0.4-2.9-1.6-4.8-3.3c-0.7,1.4-1.1,2.9-1.1,4.5C19,36.5,19.2,37.9,19.8,39.2"
          />
        </g>
      </svg>

    )
  }
}